export const RefererStorage = {
  mounted() {
    const referer = sessionStorage.getItem("mailroom:referer");
    if (referer) {
      this.pushEvent("mailroom:referer:submitted", { referer: referer });
    }
  },
};

window.addEventListener("phx:mailroom:referer:updated", (event) => {
  sessionStorage.setItem("mailroom:referer", event.detail.referer);
});
